import React, { useState } from 'react';
import { X } from 'lucide-react';

function SubscriptionFormModal({ subscription, onSave, onClose }) {
  const [form, setForm] = useState(subscription || {
    name: '', provider: '', purpose: '', cost: '', currency: 'USD',
    billing_cycle: 'mensuel', renewal_date: '', status: 'actif', url: '', account_email: '', notes: ''
  });

  const set = (k, v) => setForm({ ...form, [k]: v });
  const inputStyle = { width: '100%', padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 14, marginBottom: 10 };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 560, maxHeight: '90vh', overflowY: 'auto' }} data-testid="subscription-form-modal">
        <div className="modal-header">
          <h3>{subscription ? "Modifier l'abonnement" : 'Nouvel abonnement'}</h3>
          <button onClick={onClose} className="modal-close"><X size={20} /></button>
        </div>
        <div style={{ padding: '0 4px' }}>
          <label style={{ fontSize: 13, fontWeight: 600 }}>Nom du service *</label>
          <input style={inputStyle} value={form.name} onChange={(e) => set('name', e.target.value)} placeholder="Ex: Infobip (WhatsApp)" data-testid="sub-name-input" />
          <label style={{ fontSize: 13, fontWeight: 600 }}>Fournisseur</label>
          <input style={inputStyle} value={form.provider} onChange={(e) => set('provider', e.target.value)} placeholder="Ex: Infobip" />
          <label style={{ fontSize: 13, fontWeight: 600 }}>Usage / description</label>
          <input style={inputStyle} value={form.purpose} onChange={(e) => set('purpose', e.target.value)} placeholder="À quoi sert ce service ?" />
          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Coût</label>
              <input type="number" style={inputStyle} value={form.cost} onChange={(e) => set('cost', e.target.value)} placeholder="0" data-testid="sub-cost-input" />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Devise</label>
              <select style={inputStyle} value={form.currency} onChange={(e) => set('currency', e.target.value)}>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="CDF">CDF</option>
              </select>
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Cycle</label>
              <select style={inputStyle} value={form.billing_cycle} onChange={(e) => set('billing_cycle', e.target.value)}>
                <option value="mensuel">Mensuel</option>
                <option value="annuel">Annuel</option>
                <option value="usage">À l'usage</option>
              </select>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Date de renouvellement</label>
              <input type="date" style={inputStyle} value={form.renewal_date} onChange={(e) => set('renewal_date', e.target.value)} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Statut</label>
              <select style={inputStyle} value={form.status} onChange={(e) => set('status', e.target.value)}>
                <option value="actif">Actif</option>
                <option value="à renouveler">À renouveler</option>
                <option value="résilié">Résilié</option>
              </select>
            </div>
          </div>
          <label style={{ fontSize: 13, fontWeight: 600 }}>URL du portail de gestion</label>
          <input style={inputStyle} value={form.url} onChange={(e) => set('url', e.target.value)} placeholder="https://..." />
          <label style={{ fontSize: 13, fontWeight: 600 }}>E-mail du compte</label>
          <input style={inputStyle} value={form.account_email} onChange={(e) => set('account_email', e.target.value)} placeholder="compte@exemple.com" />
          <label style={{ fontSize: 13, fontWeight: 600 }}>Notes</label>
          <textarea style={{ ...inputStyle, minHeight: 60 }} value={form.notes} onChange={(e) => set('notes', e.target.value)} placeholder="Informations utiles (plan, plafonds, contact support...)" />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 6 }}>
            <button onClick={onClose} style={{ padding: '8px 18px', borderRadius: 8, border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }}>Annuler</button>
            <button onClick={() => onSave(form)} className="btn-primary" data-testid="sub-save-btn" style={{ padding: '8px 18px' }}>Enregistrer</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionFormModal;
